export enum OrderActionTypes {
  // multiple price requests
  START_PRICE_REQUESTS = "START_PRICE_REQUESTS",
  START_PRICE_REQUESTS_START = "START_PRICE_REQUESTS_START",
  START_PRICE_REQUESTS_SUCCESS = "START_PRICE_REQUESTS_SUCCESS",
  START_PRICE_REQUESTS_FAIL = "START_PRICE_REQUESTS_SUCCESS_FAIL",

  START_TRAINING_PRICE_REQUESTS_START = "START_TRAINING_PRICE_REQUESTS_START",

  START_OFFER_TO_ORDER = "START_OFFER_TO_ORDER",
  START_PARTIAL_OFFER_TO_ORDER = "START_PARTIAL_OFFER_TO_ORDER",

  // commissions
  FETCH_COMMISSIONS = "FETCH_COMMISSIONS",
  FETCH_COMMISSIONS_START = "FETCH_COMMISSIONS_START",
  FETCH_COMMISSIONS_SUCCESS = "FETCH_COMMISSIONS_SUCCESS",
  FETCH_COMMISSIONS_FAIL = "FETCH_COMMISSIONS_FAIL",
  REMOVE_COMMISSION = "REMOVE_COMMISSION",

  // price request
  FETCH_PRICE_REQUEST = "FETCH_PRICE_REQUEST",
  FETCH_PARTIAL_PRICE_REQUEST = "FETCH_PARTIAL_PRICE_REQUEST",
  FETCH_PRICE_REQUEST_START = "FETCH_PRICE_REQUEST_START",
  FETCH_PRICE_REQUEST_SUCCESS = "FETCH_PRICE_REQUEST_SUCCESS",
  FETCH_PRICE_REQUEST_FAIL = "FETCH_PRICE_REQUEST_FAIL",
  FETCH_PRICE_REQUEST_PROGRESS = "FETCH_PRICE_REQUEST_PROGRESS",

  UPDATE_PRICE_REQUEST_POSITION = "UPDATE_PRICE_REQUEST_POSITION",
  SET_WAITING_FOR_UPDATE = "SET_WAITING_FOR_UPDATE",
  MODIFY_PRICE_REQUEST = "MODIFY_PRICE_REQUEST",
  MODIFY_PRICE_REQUEST_MODAL = "MODIFY_PRICE_REQUEST_MODAL", // alternative handling of ui update for currency modal
  SPLIT_PRICE_REQUEST = "SPLIT_PRICE_REQUEST",

  FETCH_ORDER_DETAILS = "FETCH_ORDER_DETAILS",
  FETCH_ORDER_FOR_MODIFY = "FETCH_ORDER_FOR_MODIFY",
  FETCH_ORDER_FOR_CHECKOUT = "FETCH_ORDER_FOR_CHECKOUT",

  UPDATE_ORDER = "UPDATE_ORDER",
  UPDATE_ORDER_START = "UPDATE_ORDER_START",
  UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS",
  UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL",

  // STATE SWITCHING
  PROCEED_TO_ORDER_CHECKOUT = "PROCEED_TO_ORDER_CHECKOUT",
  PROCEED_WITH_COMPLETE_DELIVERY = "PROCEED_WITH_COMPLETE_DELIVERY",
  PROCEED_WITH_PARTIAL_DELIVERY = "PROCEED_WITH_PARTIAL_DELIVERY",
  PROCEED_TO_ORDER_EDIT = "PROCEED_TO_ORDER_EDIT",
  PROCEED_FROM_ORDER_EDIT = "PROCEED_FROM_ORDER_EDIT",
  PROCEED_TO_ORDER_CONFIRMATION = "PROCEED_TO_ORDER_CONFIRMATION",

  CONFIRM_ORDER = "CONFIRM_ORDER",
  CONFIRM_ORDER_START = "CONFIRM_ORDER_START",
  CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS",
  CONFIRM_ORDER_FAIL = "CONFIRM_ORDER_FAIL",

  FETCH_ORDER_CONFIRMATION = "FETCH_ORDER_CONFIRMATION",
  FETCH_ORDER_CONFIRMATION_START = "FETCH_ORDER_CONFIRMATION_START",
  FETCH_ORDER_CONFIRMATION_SUCCESS = "FETCH_ORDER_CONFIRMATION_SUCCESS",
  FETCH_ORDER_CONFIRMATION_FAIL = "FETCH_ORDER_CONFIRMATION_FAIL"
}

// export enum OrderStage {
//   Request = "PriceRequest",
//   Edit = "Edit",
//   Review = "Review",
//   Confirmation = "Confirmation"
// }

// export const OrderCheckoutRoute = {
//   [OrderStage.Request]: "/cart/order/priceRequest/",
//   [OrderStage.Edit]: "/cart/order/edit/",
//   [OrderStage.Review]: "/cart/order/review/",
//   [OrderStage.Confirmation]: "/cart/order/confirmation/"
// };
